import { render, staticRenderFns } from "./OutstandingTests.vue?vue&type=template&id=611afcad&"
import script from "./OutstandingTests.vue?vue&type=script&lang=js&"
export * from "./OutstandingTests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports